import React from "react";
import {
  Home as HomeIcon,
  User,
  ShoppingBag,
  ShoppingCart,
  Package,
  UtensilsCrossed,
  CalendarClock,
  Ticket,
  Palmtree,
  Car,
  CalendarCheck,
  Gamepad2,
  Puzzle,
  Dice5,
  Swords,
  Trophy,
  Shirt,
  Cpu,
  Baby,
  Sparkles,
  Briefcase,
  BookOpen,
  Armchair,
  ChefHat,
  Wheat,
  ShoppingBagIcon,
  Plane,
  Dices,
  Dumbbell,
  Gift,
  GlassWater,
  Palette,
  Wrench,
  Gamepad,
  PawPrint,
  Pizza,
} from "lucide-react";
import { Chat } from "phosphor-react";
import { Assistant } from "@mui/icons-material";
import { FaGuilded } from "react-icons/fa6";

/* ═══════════════════════════════════════════════════════════
   TYPES
   icon   -> always rendered (already-sized JSX element, e.g. <Home size={20} />)
   image  -> optional photo/artwork; UI should prefer `image` when present
             and fall back to `icon` when it isn't.
   parentId -> links a subcategory to its top-level section id below
             (Home=1, Shopping=2, Booking=3, Games=4). Top-level
             entries themselves use parentId: null.
═══════════════════════════════════════════════════════════ */
export interface CategoryItem {
  id: number;
  name: string;
  icon: React.ReactNode;
  image?: any; // optional photo — falls back to the icon if omitted
  parentId?: number | null;
  color?: string;
}

/* ═══════════════════════════════════════════════════════════
   1️⃣  TOP-LEVEL APP SECTIONS (superapp sidebar / tab bar)
   These ids (1-4) are the parentId targets for every
   subcategory array further down.
═══════════════════════════════════════════════════════════ */
export const appCategories: CategoryItem[] = [
  { id: 1, name: "Home",     parentId: null, color: "#0EA5E9", icon: <HomeIcon size={18} /> },
  { id: 2, name: "Shopping", parentId: null, color: "#0EA5E9", icon: <ShoppingBag size={18} /> },
  { id: 3, name: "Booking",  parentId: null, color: "#0EA5E9", icon: <CalendarClock size={18} /> },
    { id: 4, name: "Orders",    parentId: null, color: "#0EA5E9", icon: <Gamepad2 size={18} /> },
        { id: 5, name: "Chat",     parentId: null, color: "#7b0600", icon: <Chat size={18} /> },
  
         { id: 6, name: "HeartGuide",     parentId: null, color: "#00ffbb", icon: <Chat size={18} /> },
  
   
]

/* ═══════════════════════════════════════════════════════════
   2️⃣  SUBCATEGORIES
   Every entry below points back at one of the four ids above
   via parentId. Add an `image` (e.g. image: require("../assets/
   categories/groceries.png")) whenever real artwork exists —
   until then the icon renders on its own.

   NOTE: ids 207-213 map directly to AtlasHome.tsx's
   SCREEN_COMPONENTS (Beauty/Bags/Books/Furniture/Kitchen/
   Automotive/Farm) — keep these ids in sync with that file.
═══════════════════════════════════════════════════════════ */
export const appSubcategories: CategoryItem[] = [
  /* ── Home (parentId: 1) ── */
  { id: 101, parentId: 1, name: "Home",    color: "#0EA5E9", icon: <HomeIcon size={14} /> },
  { id: 102, parentId: 1, name: "Profile", color: "#0EA5E9", icon: <User size={14} /> },

/* ── Shopping (parentId: 2) ── */
{ id: 201, parentId: 2, name: "FOOD CENTRAL",         color: "#FF7043", icon: <UtensilsCrossed size={14} /> },
{ id: 202, parentId: 2, name: "Groceries",         color: "#dc0000", icon: <UtensilsCrossed size={14} /> },
{ id: 203, parentId: 2, name: "FOOD",              color: "#007612", icon: <UtensilsCrossed size={14} /> },
{ id: 204, parentId: 2, name: "Products",          color: "#2196F3", icon: <Package size={14} /> },
{ id: 205, parentId: 2, name: "Fashion",           color: "#2fff00", icon: <Shirt size={14} /> },
{ id: 206, parentId: 2, name: "Electronics",       color: "#455A64", icon: <Cpu size={14} /> },
{ id: 207, parentId: 2, name: "Baby & Maternity",  color: "#F06292", icon: <Baby size={14} /> },
{ id: 208, parentId: 2, name: "Beauty",            color: "#EC407A", icon: <Sparkles size={14} /> },
{ id: 209, parentId: 2, name: "Bags",              color: "#6D4C41", icon: <Briefcase size={14} /> },
{ id: 210, parentId: 2, name: "Books",             color: "#5E35B1", icon: <BookOpen size={14} /> },
{ id: 211, parentId: 2, name: "Furniture",         color: "#8D6E63", icon: <Armchair size={14} /> },
{ id: 212, parentId: 2, name: "Kitchen",           color: "#EF6C00", icon: <ChefHat size={14} /> },
{ id: 213, parentId: 2, name: "Automotive",        color: "#37474F", icon: <Car size={14} /> },
{ id: 214, parentId: 2, name: "Art & Crafts",      color: "#E040FB", icon: <Palette size={14} /> },
{ id: 215, parentId: 2, name: "Aviation",          color: "#0288D1", icon: <Plane size={14} /> },
{ id: 216, parentId: 2, name: "Gaming",            color: "#7E57C2", icon: <Gamepad size={14} /> },
{ id: 217, parentId: 2, name: "Gifts",             color: "#FF5252", icon: <Gift size={14} /> },
{ id: 218, parentId: 2, name: "Pets",              color: "#FFA726", icon: <PawPrint size={14} /> },
{ id: 219, parentId: 2, name: "Restaurant",        color: "#FFB300", icon: <GlassWater size={14} /> },
{ id: 220, parentId: 2, name: "Sports",            color: "#26A69A", icon: <Dumbbell size={14} /> },
{ id: 221, parentId: 2, name: "Tools",             color: "#78909C", icon: <Wrench size={14} /> },
{ id: 222, parentId: 2, name: "Toys",              color: "#AB47BC", icon: <Dices size={14} /> },


  /* ── Booking (parentId: 3) ── */
  { id: 301, parentId: 3, name: "Vacation Rentals",           color: "#8E44AD", icon: <Ticket size={14} /> },
  
  //{ id: 302, parentId: 3, name: "Hotels",           color: "#8E44AD", icon: <Ticket size={14} /> },
  //{ id: 303, parentId: 3, name: "Vacant Rentals",  color: "#00897B", icon: <Palmtree size={14} /> },
  //{ id: 304, parentId: 3, name: "Cleaners",             color: "#C62828", icon: <Car size={14} /> },
  //{ id: 305, parentId: 3, name: "Movers",       color: "#F57C00", icon: <CalendarCheck size={14} /> },
  //{ id: 306, parentId: 3, name: "Tickets",       color: "#F57C00", icon: <CalendarCheck size={14} /> },
  //{ id: 307, parentId: 3, name: "Appointment",       color: "#F57C00", icon: <CalendarCheck size={14} /> },
  { id: 308, parentId: 3, name: "Ride",       color: "#F57C00", icon: <CalendarCheck size={14} /> },


        { id: 401, parentId: 4, name: "Orders", color: "#afa900", icon: <ShoppingBag size={14} /> },
          
        { id: 403, parentId: 4, name: "Food Orders", color: "#d10000", icon: <Pizza size={14} /> },  
        
        { id: 402, parentId: 4, name: "Trips", color: "#7e0000", icon: <Plane size={14} /> },

    { id: 501, parentId: 5, name: "Chat", color: "#7e0000", icon: <Chat size={14} /> },
    { id: 601, parentId: 6, name: "HeartGuide Assistant", color: "#7e0000", icon: <ShoppingBag size={14} /> },

];

/* ═══════════════════════════════════════════════════════════
   3️⃣  HELPERS
═══════════════════════════════════════════════════════════ */

// Every subcategory belonging to a given top-level section id
export const getAppSubcategories = (parentId: number): CategoryItem[] =>
  appSubcategories.filter((c) => c.parentId === parentId);

// Prefer image, fall back to icon
export const renderAppCategoryVisual = (
  item: CategoryItem,
  size: number = 24
) =>
  item.image ? (
    <img
      src={item.image}
      alt={item.name}
      width={size}
      height={size}
      style={{ objectFit: "cover", borderRadius: 8 }}
    />
  ) : (
    item.icon
  );